import Request from '../utilis/request';
import config from  '../config';
export function getShippments(website_id, params) {
    return Request({
        url:config.config.base_url+'/shippments/'+website_id,
        method:'get',
        params: params
    })
}

export function saveShippments(website_id, data) {
    return Request({
        url:config.config.base_url+'/api/shippments/'+website_id,
        method:'post',
        data: data,
    })
}

export function getWebsiteShippment(is_international,weight) {
    return Request({
        url:config.config.base_url+'/drop/shippments/'+is_international+'/'+weight,
        method:'get'
    })
}
